import { usePolicyOutletContext } from "~/pages/shared/policy/hooks/usePolicyOutletContext";
import { PolicyOverviewTab } from "~/pages/shared/policy/tabs/PolicyOverviewTab";

export function OrganizationPolicyOverviewTab() {
  const { scope } = usePolicyOutletContext();
  return (
    <PolicyOverviewTab
      entityMrn={scope.mrn}
      defaultScopeType="Spaces"
      hideOrganizationFilters
    />
  );
}
